import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faLightbulb,
  faNetworkWired,
  faGlobe,
  faPenNib,
} from '@fortawesome/free-solid-svg-icons';

import DefaultBanner from '../../../components/DefaultBanner/DefaultBanner';
import Link from '../../../components/Link';

import {
  Grid,
  Row,
  Col,
} from '../../../incubation/components/ResponsiveGridLayout';

import s from './WebDesign.scss';

class WebDesign extends React.Component {
  render() {
    return (
      <React.Fragment>
        <DefaultBanner
          breadcrumb={
            <ul
              className="breadcrumb"
              itemScope
              itemType="https://schema.org/BreadcrumbList"
            >
              <li
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <Link
                  itemProp="item"
                  itemType="https://schema.org/Thing"
                  to="/"
                >
                  <span itemProp="name">Home</span>
                </Link>
                <meta content="0" itemProp="position" />
              </li>
              <li
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <Link
                  itemProp="item"
                  itemType="https://schema.org/Thing"
                  to="/solutions"
                >
                  <span itemProp="name">Solutions</span>
                  <meta content="1" itemProp="position" />
                </Link>
              </li>
              <li>Web Design</li>
            </ul>
          }
          header="Web Design"
          subHeader="Beautiful custom websites"
        />
        <section className={s.root}>
          <Grid>
            <Row>
              <Col>
                <h2>Web Design</h2>
                <p>
                  We can help you design, host and deploy your custom website so
                  that it truly expresses how professional your business is. By
                  default, all our websites are built to look perfect on both
                  desktop and mobile so you don't have to worry about how your
                  users browse the web.
                </p>
                <h2>Webflow</h2>
                <p>
                  Webflow is a powerful tool for building custom websites and
                  allowing the content to be easily managed. It's built in
                  content management system allows anybody to change images,
                  text, and other assets whether they have programming
                  experience or not.
                </p>
              </Col>
            </Row>
          </Grid>
        </section>
        <section className={s.planningToProduction}>
          <Grid>
            <Row>
              <Col lg={12}>
                <h2>From Planning to Production</h2>
                <p>
                  We help businesses bring websites from an idea to the web in a
                  series of four steps. Every step along the way, we'll be here
                  to help make sure your website is the success it needs to be.
                </p>
              </Col>
              <Col lg={6}>
                <div className={s.info}>
                  <div className={s.circleContainer}>
                    <FontAwesomeIcon className={s.faIcon} icon={faLightbulb} />
                  </div>
                  <div className={s.content}>
                    <h3>Idea</h3>
                    <p>
                      Here we help take you from idea to business model.
                      Consulting you on what works and what doesn't.
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div className={s.info}>
                  <div className={s.circleContainer}>
                    <FontAwesomeIcon
                      className={s.faIcon}
                      icon={faNetworkWired}
                    />
                  </div>
                  <div className={s.content}>
                    <h3>Wireframe & Mockup</h3>
                    <p>
                      Wireframes and mockups are used to thoroughly plan the app
                      out. Planning is crucial for estimating cost and saving
                      time on the development side of things; however, for
                      static websites this step may be skiped.
                    </p>
                  </div>
                </div>
              </Col>

              <Col lg={6}>
                <div className={s.info}>
                  <div className={s.circleContainer}>
                    <FontAwesomeIcon className={s.faIcon} icon={faPenNib} />
                  </div>
                  <div className={s.content}>
                    <h3>Design</h3>
                    <p>
                      This part of the process is dedicated to building out the
                      website in Webflow. We take pen to paper and start
                      creating.
                    </p>
                  </div>
                </div>
              </Col>

              <Col lg={6}>
                <div className={s.info}>
                  <div className={s.circleContainer}>
                    <FontAwesomeIcon className={s.faIcon} icon={faGlobe} />
                  </div>
                  <div className={s.content}>
                    <h3>Going Live</h3>
                    <p>
                      We usually have at least one review cycle before going
                      live. After review we push a button and allow your website
                      to be viewed by the rest of the world!
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </section>
      </React.Fragment>
    );
  }
}

export default withStyles(s)(WebDesign);
